import { RingProgress, Stack, Text } from "@mantine/core";
import React, { useState, useEffect } from "react";

interface CountdownTimerProps {
  initialSeconds: number;
  onFinish: () => void;
  startCountdown: boolean;
  resetCountdown: boolean;
  size?: "small" | "large";
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  initialSeconds,
  onFinish,
  startCountdown,
  resetCountdown,
  size = "large",
}) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(false);
      onFinish();
      if (interval) clearInterval(interval);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, seconds, onFinish]);

  useEffect(() => {
    if (startCountdown) {
      setIsActive(true);
    }
  }, [startCountdown]);

  useEffect(() => {
    if (resetCountdown) {
      setSeconds(initialSeconds);
      setIsActive(true);
    }
  }, [resetCountdown, initialSeconds]);

  const sizeInfo = size === "large" ? 50 : 40;
  const colorIno = size === "large" ? "blue" : "";
  return (
    <Stack justify="center" align="center">
      <RingProgress
        sections={[{ value: (seconds / initialSeconds) * 100, color: "blue" }]}
        size={sizeInfo}
        thickness={3}
        label={
          <Text c={colorIno} fw={20} ta="center" size="xs">
            {seconds}
          </Text>
        }
      />
    </Stack>
  );
};

export default CountdownTimer;
